module.exports = __webpack_public_path__ + "img/1746687761302-WhatsApp Image 2025-05-08 at 15.01.45 1.jpeg.6aa98734.webp";